module.exports = __webpack_public_path__ + "assets/img/honor2.8c777cb6.png";